import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import SolidGauge from 'highcharts/modules/solid-gauge'
import HighchartsReact from 'highcharts-react-official'
import { formatAmount } from '../../modules/utils/formatters'
import { DatumTotal, GlobalStyle, GridContainer, GridItem, NameTop, Percentage, Strong } from './DonutsChart.styles'

if (!Highcharts.__isConfigured) {
  HighchartsMore(Highcharts)
  SolidGauge(Highcharts)
  Highcharts.__isConfigured = true
}

const DonutsChart = ({ data, id }) => {
  const theme = useTheme()

  const baseOptions = {
    accessibility: { enabled: false },
    chart: { height: '100%', type: 'solidgauge' },
    pane: {
      background: [
        {
          backgroundColor: theme.palette.brand.gray2,
          borderWidth: 0,
          innerRadius: '0%',
          outerRadius: '100%'
        },
        {
          backgroundColor: theme.palette.brand.white,
          borderWidth: 0,
          innerRadius: '0%',
          outerRadius: '62%'
        }
      ],
      endAngle: 360,
      startAngle: 0
    },
    plotOptions: {
      solidgauge: {
        dataLabels: { enabled: false }
      }
    },
    title: { text: undefined },
    tooltip: { enabled: false },
    yAxis: {
      lineWidth: 0,
      max: 100,
      min: 0,
      tickPositions: []
    }
  }

  return (
    <>
      <GlobalStyle />
      <GridContainer id={id} alignItems="flex-end">
        {data.map((datum, index) => {
          const chartOptions = {
            ...baseOptions,
            series: [
              {
                data: [
                  {
                    color: datum.color,
                    radius: '100%',
                    y: datum.percentage
                  }
                ]
              }
            ]
          }

          return (
            <GridItem xs key={index}>
              <GridContainer align="center">
                <GridItem xs={12}>
                  <GridItem xs={6}>
                    <NameTop>{datum.name}</NameTop>
                    <Strong>{formatAmount(datum.data)}</Strong>&nbsp;<Percentage>({datum.percentage}%)</Percentage>
                  </GridItem>
                </GridItem>
              </GridContainer>
              <GridContainer justifyContent="center">
                <GridItem xs={6}>
                  <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12}>
                  <DatumTotal>
                    Total: <Strong>{formatAmount(datum.dataTotals)}</Strong>
                  </DatumTotal>
                </GridItem>
              </GridContainer>
            </GridItem>
          )
        })}
      </GridContainer>
    </>
  )
}

DonutsChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.number,
      dataTotals: PropTypes.number,
      color: PropTypes.string,
      name: PropTypes.string,
      percentage: PropTypes.number,
      tooltip: PropTypes.string
    })
  ).isRequired,
  id: PropTypes.string.isRequired
}

export default DonutsChart
